import moment from "moment-timezone";
export var DEFAULT_TIMEZONE = "Europe/Zurich";
// After 16:00 CE(S)T, default booking dates shift to next day.
var BOOKING_CUTOFF_HOUR = 16;
/**
 * Returns the default arrival and departure dates based on the current time in CE(S)T.
 * If current time is >= 16:00 CE(S)T, dates shift to tomorrow/day after tomorrow.
 */ export var getDefaultBookingDates = function() {
    var now = moment().tz(DEFAULT_TIMEZONE);
    var isAfterCutoff = now.hour() >= BOOKING_CUTOFF_HOUR;
    var arrivalDate = isAfterCutoff ? now.clone().add(1, "day").format("YYYY-MM-DD") : now.format("YYYY-MM-DD");
    var departureDate = isAfterCutoff ? now.clone().add(2, "days").format("YYYY-MM-DD") : now.clone().add(1, "day").format("YYYY-MM-DD");
    return {
        arrivalDate: arrivalDate,
        departureDate: departureDate
    };
};
export var formatLocalizedDate = function(dateString, locale) {
    var _parts_find, _parts_find1, _parts_find2, _parts_find3;
    if (!dateString) return "";
    var date = new Date(dateString);
    var formatter = new Intl.DateTimeFormat(locale, {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric"
    });
    var parts = formatter.formatToParts(date);
    var weekday = (_parts_find = parts.find(function(part) {
        return part.type === "weekday";
    })) === null || _parts_find === void 0 ? void 0 : _parts_find.value;
    var day = (_parts_find1 = parts.find(function(part) {
        return part.type === "day";
    })) === null || _parts_find1 === void 0 ? void 0 : _parts_find1.value;
    var month = (_parts_find2 = parts.find(function(part) {
        return part.type === "month";
    })) === null || _parts_find2 === void 0 ? void 0 : _parts_find2.value;
    var year = (_parts_find3 = parts.find(function(part) {
        return part.type === "year";
    })) === null || _parts_find3 === void 0 ? void 0 : _parts_find3.value;
    // Handle different locales for formatting
    if (locale.startsWith("de")) {
        // German style: "Fr, 21. Juni 2024"
        return "".concat(weekday, ", ").concat(day, ". ").concat(month, " ").concat(year);
    } else {
        // Default style (English): "Fri, 21 June 2024"
        return "".concat(weekday, ", ").concat(day, " ").concat(month, " ").concat(year);
    }
};
